<div class="modal-header">
    <h4 class="modal-title fw-bold">
        <span *ngIf="nameId" jhiTranslate="germplasm-name-modal.edit.header"></span>
        <span *ngIf="!nameId" jhiTranslate="germplasm-name-modal.create.header"></span>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="container">
	<div class="modal-body">
		<form name="form" #f="ngForm">
			<div class="mb-3 row required">
				<label for="dropdownTypes" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm-name-modal.type">Name Type</label>
				<div class="col-sm-9">
					<ng-select name="dropdownTypes" id="dropdownTypes" width="100%"
                               bindValue="code"
                               bindLabel="code"
                               [(ngModel)]="nameTypeCode"
                               [items]="nameTypes | async">
					</ng-select>
				</div>
			</div>
			<div class="mb-3 row required">
				<label for="germplasmname" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm-name-modal.name">Name</label>
				<div class="col-sm-9">
					<textarea rows="3" class="form-control" name="germplasmname" id="germplasmname" [(ngModel)]="name" jhi-forbiddenCharactersValidator #germplasmname="ngModel" maxlength="5000"></textarea>
				</div>
			</div>
			<div class="mb-3 row required">
				<label for="germplasmdate" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm-name-modal.date">Date</label>
                <div class="col-sm-9">
                    <div class="input-group">
                        <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="date"
                               ngbDatepicker #germplasmdate="ngbDatepicker" id="germplasmdate" name="date" required/>
                        <button class="btn btn-outline-secondary calendar" (click)="germplasmdate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                    </div>
                </div>
			</div>
			<div class="mb-3 row required">
				<label for="dropdownLocations" class="col-sm-3 col-form-label fw-bold" jhiTranslate="germplasm-name-modal.location">Location</label>
				<div class="col-sm-9">
					<jhi-locations-select id="dropdownLocations" [(value)]="locationId" [showFilterOptions]="false" [clearable]="false"></jhi-locations-select>
				</div>
			</div>
			<div class="mb-3 row">
				<label for="germplasmpreferred" class="col-sm-3 col-form-label"></label>
				<div class="col-sm-9">
					<input type="checkbox" class="form-check-input" name="germplasmpreferred" id="germplasmpreferred" [(ngModel)]="preferred">&nbsp;<label for="germplasmpreferred" jhiTranslate="germplasm-name-modal.preferred">Preferred Name</label>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
			<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
		</button>
		<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span class="fa fa-save"></span>&nbsp;
			<span *ngIf="nameId" jhiTranslate="update"></span>
			<span *ngIf="!nameId" jhiTranslate="create"></span>
		</button>
	</div>
</div>
